import React, { useMemo } from "react";
import useFetchData from "../../hooks/useFetchData";
import ChartWrapper from "../../Pages/ApplicationBlock/ChartRenderer/ChartWrapper";
import { defaultChartThemeConfig } from "../../Pages/ApplicationBlock/ChartRenderer/defaultChartTheme";

const SingleChartPreview = ({ config, classes }) => {
  const apiUrl = useMemo(() => {
    return config.chart_template_id ? `/sysconfigs/${config.chart_template_id}` : null;
  }, [config.chart_template_id]);

  const { data } = useFetchData(apiUrl, [], null);
  return (
    <div className={`z-rv-chart ${classes}`}>
      {config.chart_type === "table" ? (
        <div>
          <div>
            <h1>{config.title}</h1>
          </div>
          <div className="user_table">
            <table>
              <thead>
                <tr>
                  <th>{config.xaxis_title}</th>
                  <th>{config.yaxis_title}</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(2)].map((_, index) => (
                  <tr key={index}>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <ChartWrapper chartConfig={config} themeConfig={data?.config ?? defaultChartThemeConfig} />
      )}
    </div>
  );
};

export default React.memo(SingleChartPreview);
